import { useEffect, useRef } from "react";
import {
  applyCatalogSearchQuery,
  applyOfferModeToSearchParams,
  hasCatalogListFilters,
  isOfferModeFromSearchParams,
} from "../utils/catalogTabState";

/**
 * When the search query changes, clear category/subcategory (and optional brand) filters
 * while keeping the same query on browser back from product detail.
 */
export function useResetCatalogFiltersOnQueryChange({
  searchParams,
  queryValue,
  onApply,
  includeBrands = true,
  preserveOfferMode = false,
}) {
  const prevQueryRef = useRef(null);
  const onApplyRef = useRef(onApply);
  onApplyRef.current = onApply;

  useEffect(() => {
    const q = String(queryValue || "").trim();
    if (prevQueryRef.current === null) {
      prevQueryRef.current = q;
      return;
    }
    if (prevQueryRef.current === q) return;
    prevQueryRef.current = q;

    if (!hasCatalogListFilters(searchParams, { includeBrands })) return;

    let next = applyCatalogSearchQuery(searchParams, q, { includeBrands });
    if (preserveOfferMode) {
      next = applyOfferModeToSearchParams(next, isOfferModeFromSearchParams(searchParams));
    }
    onApplyRef.current(next);
  }, [queryValue, searchParams, includeBrands, preserveOfferMode]);
}
